import React, { useEffect } from "react";
import { Star, ThumbsUp } from "lucide-react";

export const ReviewsSection: React.FC = () => {
  useEffect(() => {
    // Only inject script when user interacts or after 4s idle
    let scriptInjected = false;
    const loadScript = () => {
      if (scriptInjected || document.getElementById("reputation-widget-script")) return;
      scriptInjected = true;
      const script = document.createElement("script");
      script.id = "reputation-widget-script";
      script.type = "text/javascript";
      script.src = "https://reputationhub.site/reputation/assets/review-widget.js";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    };

    const timer = setTimeout(loadScript, 5000);
    const handleInteraction = () => {
      loadScript();
      window.removeEventListener("scroll", handleInteraction);
      window.removeEventListener("touchstart", handleInteraction);
    };
    window.addEventListener("scroll", handleInteraction, { passive: true });
    window.addEventListener("touchstart", handleInteraction, { passive: true });

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", handleInteraction);
      window.removeEventListener("touchstart", handleInteraction);
    };
  }, []);
  return (
    <section id="reviews" className="py-12 sm:py-20 bg-slate-50 text-slate-950 relative overflow-hidden">
      {/* Background glow effects */}
      <div className="absolute top-1/2 left-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-amber-400/10 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8 relative z-10">
        
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 bg-amber-400 text-slate-950 font-black px-4 py-1.5 rounded-full text-xs uppercase tracking-widest mb-4">
            <Star className="w-4 h-4 fill-slate-950" /> Davie Customer Reviews
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black font-heading uppercase tracking-tight mb-4">
            What Our <span className="text-primary">Davie</span> Customers Say
          </h2>
          <p className="text-slate-600 text-base sm:text-lg">
            Real reviews from our Davie & Broward County customers.
          </p>
        </div>

        {/* Aggregate Stats Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 mb-10 sm:mb-12 max-w-4xl mx-auto">
          <div className="bg-white border-2 border-slate-200 p-4 sm:p-6 rounded-2xl text-center shadow-sm">
            <div className="text-3xl sm:text-4xl font-black text-amber-500 font-heading mb-1">5.0 / 5.0</div>
            <div className="flex justify-center gap-1 mb-2">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
              ))}
            </div>
            <div className="text-xs text-slate-500 font-bold uppercase tracking-wider">
              Google Verified Score
            </div>
          </div>

          <div className="bg-white border-2 border-slate-200 p-4 sm:p-6 rounded-2xl text-center shadow-sm">
            <div className="text-3xl sm:text-4xl font-black text-primary font-heading mb-1">100%</div>
            <div className="text-sm font-bold text-slate-950 mb-2">Upfront Pricing</div>
            <div className="text-xs text-slate-500 font-bold uppercase tracking-wider">
              Zero Hidden Charges
            </div>
          </div>
          <div className="bg-white border-2 border-slate-200 p-4 sm:p-6 rounded-2xl text-center shadow-sm">
            <div className="text-3xl sm:text-4xl font-black text-emerald-500 font-heading mb-1">Same-Day</div>
            <div className="text-sm font-bold text-slate-950 mb-2">Hauling Available</div>
            <div className="text-xs text-slate-500 font-bold uppercase tracking-wider">
              Across Davie &amp; Broward
            </div>
          </div>
        </div>
        {/* Reputation Hub Live Review Widget — 4-col × 2-row Grid */}
        <div className="max-w-7xl mx-auto">
          <div className="bg-white border-2 border-slate-200 rounded-2xl sm:rounded-3xl p-1 sm:p-4 md:p-10 shadow-sm overflow-hidden">
            <iframe
              className="lc_reviews_widget w-full rounded-lg sm:rounded-2xl lazy-load-iframe"
              data-src="https://reputationhub.site/reputation/widgets/review_widget/xfaKqeYCXXqhpM9mQvnB"
              frameBorder="0"
              scrolling="yes"
              style={{ minHeight: "500px", width: "100%", border: "none" }}
              title="Muscle Junk Removal Customer Reviews"
              loading="lazy"
            />
          </div>
        </div>
        {/* Leave a review / Google callout */}
        <div className="text-center mt-12">
          <p className="text-slate-500 text-sm mb-4">
            Are you a recent customer? We'd love to hear about your experience!
          </p>
          <a
            href="https://www.google.com/search?q=Muscle+Junk+Removal+Davie+FL"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-primary hover:bg-primary/90 text-white px-6 py-2.5 rounded-xl font-bold text-sm transition-colors"
          >
            <ThumbsUp className="w-4 h-4" /> Leave Us a Review on Google
          </a>
        </div>

      </div>
    </section>
  );
};
